import { render, staticRenderFns } from "./BtTaiwanRankingChart.vue?vue&type=template&id=3410cdf2&scoped=true&"
import script from "./BtTaiwanRankingChart.vue?vue&type=script&lang=js&"
export * from "./BtTaiwanRankingChart.vue?vue&type=script&lang=js&"
import style0 from "./BtTaiwanRankingChart.vue?vue&type=style&index=0&id=3410cdf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3410cdf2",
  null
  
)

export default component.exports